export default "__VITE_ASSET__Wk83anyH__"